import styled from "styled-components"
import { theme } from "Theme"

export const EventCard = styled.div`
  border-radius: ${theme.borderRadius.ui};
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: row;
  box-shadow: ${theme.shadow.feature.small.default};
  @media (max-width: ${theme.breakpoints.m}) {
    flex-direction: column;
  }
`

export const EventCardTitle = styled.h2`
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.medium};
  font-weight: bold;
  width: 100%;
  max-width: ${theme.layout.base};
`

export const EventCardSubtitle = styled.p`
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.small};
  font-weight: bold;
  margin-bottom: 0rem;
`

export const EventCardEmpty = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.small};
  background: #eee;
  border-radius: ${theme.borderRadius.ui};
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: row;
  a {
    width: 100%;
    p {
      margin: 0;
    }
  }
  @media (max-width: ${theme.breakpoints.m}) {
    flex-direction: column;
  }
`
